import { Trash } from "lucide-react";
import { Button } from "../button";
import { deleteRecord } from "@/api/record";
import {
  Dialog,
  DialogContent,
  DialogTitle,
  DialogHeader,
  DialogFooter,
  DialogClose,
} from "../dialog";
import { HGRecord } from "@/common/types";
import { useState } from "react";
import { DialogTrigger } from "@radix-ui/react-dialog";
// import { useNavigate, useLocation } from "react-router";
import { globalReloader } from "@/providers/dbRecordsLoader";
import { selectViewingRecord, setViewingRecord } from "@/state/redux/slices/ui";
import { useAppDispatch, useAppSelector } from "@/state/redux/hooks";

export interface RecordDeleteProps {
  record: HGRecord;
}

export function RecordDelete({ record }: RecordDeleteProps) {
  const [open, setOpen] = useState(false);
  const viewingRecord = useAppSelector(selectViewingRecord);
  const dispatch = useAppDispatch();

  // const navigate = useNavigate();
  // const location = useLocation();
  // const from = location.state?.from?.pathname || "/";

  const handleDelete = () => {
    deleteRecord(record.id)
      // .then(() => navigate(from))
      .then(() => globalReloader.reload());
    setOpen(false);
    if (viewingRecord?.id == record.id) {
      dispatch(setViewingRecord(null));
    }
  };
  return (
    <>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogTrigger asChild>
          <Button
            variant="outline"
            className="border-destructive text-destructive hover:bg-destructive/5"
          >
            <Trash />
            Delete
          </Button>
        </DialogTrigger>
        <DialogContent>
          <DialogHeader>
            <DialogTitle>Delete record</DialogTitle>
          </DialogHeader>
          <div className="flex flex-col gap-2">
            <p>
              Are you sure you want to delete this record? This action cannot be
              undone.
            </p>
            {/* The collection survives — only its heading goes. Worth saying
                out loud, because "delete the record that is the collection"
                reads like it might take the collection with it. */}
            {record.title_collection_id && (
              <p className="text-[13px] text-muted-foreground">
                This record is the title of a collection. The collection and
                everything in it stay; it is simply left without a title record.
              </p>
            )}
          </div>
          <DialogFooter>
            <DialogClose asChild>
              <Button variant="outline">Cancel</Button>
            </DialogClose>
            <Button onClick={handleDelete} variant="destructive">
              Delete
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
    </>
  );
}
